import React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import TodoDashboard from '../../../components/TodoDashboard/TodoDashboard';
import FollowUpDashboard from '../../../components/FollowUpDashboard/FollowUpDashboard';
import {
    getFollowUpRecoveryActions,
    getSearchFollowUpRecoveryActions,
    getIsFollowUpFetching,
    getTodoRecoveryActions,
    getSearchTodoRecoveryActions,
    getIsTodoFetching,
    storeSearchTodoRecoveryActions,
    loadTodoRecoveryActions,
    storeSearchFollowUpRecoveryActions,
    loadFollowUpRecoveryActions,
    INITIAL_TODO_REC_ACTIONS_SEARCH,
    INITIAL_FOLLOW_UP_REC_ACTIONS_SEARCH,
} from '../duck';

class DashboardRecoveryActions extends React.Component {
    render() {
        const {
            todo,
            searchTodo,
            isFetchingTodo,
            loadTodoRecoveryActions,
            storeSearchTodoRecoveryActions,
            followUp,
            searchFollowUp,
            isFetchingFollowUp,
            loadFollowUpRecoveryActions,
            storeSearchFollowUpRecoveryActions,
        } = this.props;

        return (
            <Row>
                <Col style={{ margin: 20 }}>
                    <FollowUpDashboard
                        title="TODO"
                        data={todo}
                        search={searchTodo}
                        emptySearch={INITIAL_TODO_REC_ACTIONS_SEARCH}
                        isFetching={isFetchingTodo}
                        actions={{
                            loadData: loadTodoRecoveryActions,
                            storeSearch: storeSearchTodoRecoveryActions,
                        }}
                    />
                    <TodoDashboard
                        title="FOLLOW-UP"
                        data={followUp}
                        search={searchFollowUp}
                        emptySearch={INITIAL_FOLLOW_UP_REC_ACTIONS_SEARCH}
                        isFetching={isFetchingFollowUp}
                        actions={{
                            loadData: loadFollowUpRecoveryActions,
                            storeSearch: storeSearchFollowUpRecoveryActions,
                        }}
                    />
                </Col>
            </Row>
        );
    }
}

DashboardRecoveryActions.defaultProps = {
    todo: [],
    searchTodo: INITIAL_TODO_REC_ACTIONS_SEARCH,
    isFetchingTodo: false,
    followUp: [],
    searchFollowUp: INITIAL_FOLLOW_UP_REC_ACTIONS_SEARCH,
    isFetchingFollowUp: false,
};

export default connect(
    state => ({
        todo: getTodoRecoveryActions(state),
        searchTodo: getSearchTodoRecoveryActions(state),
        isFetchingTodo: getIsTodoFetching(state),
        followUp: getFollowUpRecoveryActions(state),
        searchFollowUp: getSearchFollowUpRecoveryActions(state),
        isFetchingFollowUp: getIsFollowUpFetching(state),
    }),
    {
        loadTodoRecoveryActions,
        storeSearchTodoRecoveryActions,
        loadFollowUpRecoveryActions,
        storeSearchFollowUpRecoveryActions,
    }
)(DashboardRecoveryActions);
